export default __webpack_public_path__ + "static/club-voyages-ccc5853e24c8b38da25fd60750616d34.webp";